import { ReactNode } from "react"
import { GetBackIcon } from "components/ui/icons/getBack/GetBackIcon"
import style from "./ButtonGetBack.module.scss"

const { buttonGetBack } = style

type Props = { children: ReactNode; className?: string; onClick: () => void }

export const ButtonGetBack = ({ children, className = "", onClick }: Props) => {
	return (
		<button className={`${buttonGetBack} ${className}`} onClick={onClick} data-testid="button-get-back">
			<GetBackIcon />
			{children}
		</button>
	)
}
